import { transformToHtml } from '../../utils/CommonUtils';
import { footerDomPWA, footerIntlPWA } from '../../utils/htmlUtil/htmlFooterDT';

const FooterCityPWA = (props) => {
  const { footer_data: footer, isIntl } = props?.data || {};
  let footerData = footer || '';
  if (footerData === '' && isIntl) {
    footerData = footerIntlPWA;
  } else if (footerData === '') {
    footerData = footerDomPWA;
  }

  return (
    <>
      <div id="footer_block">{ transformToHtml(footerData)}</div>
    </>
  );
};

export default FooterCityPWA;